// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.G5NOGk {
  --carousel-max-width: 100%;
  --carousel-height: auto;
  --carousel-border-radius: var(--radius-s);
  --carousel-box-shadow: 0px 2px 4px 0px #0000001f;

  width: 100%;
  border-radius: var(--carousel-border-radius);
  box-shadow: var(--carousel-box-shadow);
  background: var(--surface-neutral-white);
  cursor: pointer;
}

@media (max-width: 768px) {
  .G5NOGk {
    aspect-ratio: 4/3;
  }
}

@media (max-width: 480px) {
  .G5NOGk {
    aspect-ratio: 3/2;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/ProductBannersCarousel/ProductBannersCarousel.module.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,yCAAyC;EACzC,gDAAgD;;EAEhD,WAAW;EACX,4CAA4C;EAC5C,sCAAsC;EACtC,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".container {\n  --carousel-max-width: 100%;\n  --carousel-height: auto;\n  --carousel-border-radius: var(--radius-s);\n  --carousel-box-shadow: 0px 2px 4px 0px #0000001f;\n\n  width: 100%;\n  border-radius: var(--carousel-border-radius);\n  box-shadow: var(--carousel-box-shadow);\n  background: var(--surface-neutral-white);\n  cursor: pointer;\n}\n\n@media (max-width: 768px) {\n  .container {\n    aspect-ratio: 4/3;\n  }\n}\n\n@media (max-width: 480px) {\n  .container {\n    aspect-ratio: 3/2;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `G5NOGk`
};
module.exports = ___CSS_LOADER_EXPORT___;
